import { Activated } from "@/assets";
import { routes } from "@/consts";
import { Link } from "react-router-dom";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";

function VerifiedEmail() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <div className="flex flex-col gap-2 items-center justify-center">
      <div className="text-4xl font-bold">
        {t("comfirm.verified")}
        </div>
      <img
        width={200}
        className="text-center my-6 mx-auto"
        src={Activated}
        alt="expired token"
      />
      <Link to={routes.login} className="text-purple-600 font-semibold">
        Login
      </Link>
    </div>
  );
}

export default VerifiedEmail;
